<template>
  <div id="stud_main">
  <div v-if="isLoading" class="loading">Loading&#8230;</div>


<div @click="load_details()" class="columns colHover isLink is-multiline is-gapless is-mobile" style="margin-bottom:0em;">

<div class="column is-2 colBorder has-text-centered has-text-weight-light doFont" style="">{{data.grpSessAnn}}</div>

 
<div class="column is-6 colBorder">
<div class="columns is-multiline is-gapless">
    <div class="column is-12 has-text-weight-light doFont" style="margin-bottom:-.3em;">&nbsp;{{data.cour_TITRE_F}}</div>  
    <div class="column is-4 has-text-weight-light doFontSmaller" style="color:CADETBLUE">&nbsp;&nbsp;{{data.cour_CODE}}</div>  
    <div class="column is-8 has-text-weight-light doFontSmaller has-text-right" style="color:SADDLEBROWN">{{data.prof1}} {{data.prof2}}&nbsp;&nbsp;</div>  
</div>
</div>

<div v-if="data.cs_REMARK == 'EQ'" class="column is-2 colBorder has-text-centered has-text-weight-bold has-text-grey doFont" style="">EQ</div>
<div v-else-if="data.goodToGo == 1" class="column is-2 colBorder has-text-centered has-text-weight-bold doFont" style="">{{data.cs_MARK}}% {{return_remark(data.cs_REMARK)}}</div>
<div v-else class="column is-2 colBorder has-text-centered has-text-weight-bold has-text-warning" style="font-size:2vw;"><span class="icon" style="padding-top:1em;"><i class="fas fa-clock"></i></span></div>
 
<!-- AVERAGE  -->
<div v-if="course_avg > 0" class="column is-2 colBorder has-text-centered has-text-weight-bold doFont" style="">{{course_avg}}%</div>
<div v-else class="column is-2 colBorder has-text-centered has-text-weight-bold doFont" style=""></div>


</div>


<CompCourseDetail v-if="show_details" style="padding-bottom:2em;" class="has-background-light"
:student_id="student_id"
:group_id="data.group_ID"
:course_avg="course_avg"
>
</CompCourseDetail>


  </div>
</template>


<script>
import  CompCourseDetail  from '@/views/Student/Course_Details'


export default {
    props: [ 'student_id' ,'data' ],
    components: { CompCourseDetail },
  data: function() {
    return {
        isLoading : false,
        show_details : false,
        course_avg:-1,

    }
  },


created() {

// CHECK IF GROUP PUBLIC  - - SHOW AVERAGE
  if (this.data.goodToGo == 1) {
      this.course_avg = this.data.group_AVG
  }



},

  methods: {

    load_details() {
        if (this.data.cs_REMARK != 'EQ') {
            this.show_details=!this.show_details
        }
    },

    return_remark(remark) {
      if (remark.toLowerCase() == 'null') {return ''}
      else {return remark}
    },


  }, // END METHODS 

} // END SCRIPT
</script>




<style scoped>



.colHover:hover {
  background-color: AZURE;
}

</style>
